import React from "react";
import { setOptionEdit } from "../../reducer/tourEditReducer";
import { Paths } from "../../router/Paths";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import RoleBasedComponent from "../../components/RoleBasedComponent";

export default function ManageAddonsSection({ optionData }: any) {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleEdit = () => {
    dispatch(setOptionEdit(optionData._id));
    navigate(Paths.tourManagementPackageOptionsAvailabilityAddOn, {
      state: { optionData },
    });
  };
  return (
    <section className="bg-white p-2 sm:p-6">
      <div className="flex justify-between items-center">
        <p className="text-xl font-bold">Add-ons</p>
        <RoleBasedComponent allowedRoles={["supplier"]}>
          <button
            onClick={handleEdit}
            className="text-sm text-primary underline font-bold"
          >
            Edit
          </button>
        </RoleBasedComponent>
      </div>
      {/* content */}
      <div className="flex flex-col sm:items-end gap-6">
        <div className="w-full max-w-[836px] flex flex-col gap-6">
          {optionData?.addOns && optionData.addOns.length > 0 ? (
            optionData.addOns.map((addon: any, index: number) => (
              <div key={index} className="w-full">
                <div className="space-y-2">
                  <p className="text-sm font-bold capitalize">
                    {addon.keyword || `Addon ${index + 1}`}
                  </p>
                  {addon.tiers && addon.tiers.length > 0 ? (
                    addon.tiers.map((tier: any, i: number) => (
                      <div key={i} className="w-full">
                        <div className="space-y-2">
                          <p className="text-secondary capitalize">
                            <span>Quantity:</span> {tier.quantityFrom} -{" "}
                            {tier.quantityTo}
                          </p>
                          <p className="text-secondary capitalize">
                            <span>Customer Pays:</span> ₦{tier.customerPays}
                          </p>
                          <p className="text-secondary capitalize">
                            <span>Commission:</span> {tier.commission}
                          </p>
                          <p className="text-secondary capitalize">
                            <span>Payout:</span> ₦{tier.payout}
                          </p>
                        </div>
                      </div>
                    ))
                  ) : (
                    <p className="text-gray-500 text-xs italic">
                      No tiers available
                    </p>
                  )}
                </div>
              </div>
            ))
          ) : (
            <p className="text-secondary capitalize">N/A</p>
          )}
        </div>
      </div>
    </section>
  );
}
